var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 18.375 30.5 20.375 28.375 21.1875C29.3125 23.1875 28.9375 25.6875 27.3125 27.3125C25.625 29 23.1875 29.375 21.125 28.4375C20.3125 30.5625 18.3125 32 16 32C13.625 32 11.625 30.5625 10.8125 28.4375C8.8125 29.375 6.3125 29 4.6875 27.3125C3 25.6875 2.625 23.1875 3.5625 21.1875C1.4375 20.375 0 18.375 0 16C0 13.6875 1.4375 11.6875 3.5625 10.875C2.625 8.875 3 6.375 4.6875 4.6875C6.3125 3.0625 8.8125 2.6875 10.8125 3.625C11.625 1.5 13.625 0 16 0C18.3125 0 20.3125 1.5 21.125 3.625C23.125 2.6875 25.625 3.0625 27.3125 4.6875C28.9375 6.375 29.3125 8.875 28.375 10.875C30.5 11.6875 32 13.6875 32 16ZM22.9375 13.25C23.1875 13 23.1875 12.5625 22.9375 12.3125L21.3125 10.6875C21.0625 10.375 20.625 10.375 20.3125 10.6875L14.25 16.6875L11.625 14.0625C11.375 13.75 10.9375 13.75 10.625 14L9 15.625C8.75 15.9375 8.75 16.375 9 16.625L13.75 21.375C14 21.625 14.4375 21.6875 14.75 21.375L22.9375 13.25Z",
    fill: "url(#paint0_linear_1202_9679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1202_9679",
    x1: 2.18947,
    y1: 7.15789,
    x2: 17.1838,
    y2: 32.7679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEDAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeCheck);
export default __webpack_public_path__ + "static/media/badgeCheck.9c4b2cdb2dce9030a8fb41a492ca4718.svg";
export { ForwardRef as ReactComponent };